import type { InvariantJiraRoute } from '@atlassian/jira-route-types/src/InvariantJiraRoute.tsx';

export const communicationsStatusPageRoute: InvariantJiraRoute = {
	name: 'communications-status-page',
	path: '/jira/communications/status-page',
};
